<template>
  <div>
    <div class="text-center mb-3">
      <h2 style="font-weight: bold; color: #007bff; margin: 0;">
        Detailed Student View
      </h2>
    </div>

    <div class="mb-2">
      <b-button variant="danger" @click="$bvModal.show('download-type-modal')">Download</b-button>
    </div>

    <b-modal
      id="download-type-modal"
      title="Download Admission Forms"
      ok-title="Download"
      @ok="downloadAdmissionformFullDetails()"
      cancel-title="Cancel"
    >
      <b-form-group>
        <b-form-radio v-model="selectedExportType" value="single_file" class="mb-3">
          <div>All students in one PDF</div>
          <div class="text-muted" style="font-size: 0.85rem;">Exports all student submissions as a single PDF file.</div>
        </b-form-radio>
        <b-form-radio v-model="selectedExportType" value="all_students_individual" class="mb-3">
          <div>Each student as a separate PDF (ZIP)</div>
          <div class="text-muted" style="font-size: 0.85rem;">Generates one PDF per student, bundled into a ZIP archive.</div>
        </b-form-radio>
        <b-form-radio v-model="selectedExportType" value="single_file_with_attachment" class="mb-3">
          <div>All students with attachments in one PDF</div>
          <div class="text-muted" style="font-size: 0.85rem;">Includes uploaded attachments alongside answers in a single PDF.</div>
        </b-form-radio>
        <b-form-radio v-model="selectedExportType" value="all_students_individual_with_attachment">
          <div>Each student with attachments, individual (ZIP)</div>
          <div class="text-muted" style="font-size: 0.85rem;">One PDF per student including attachments, bundled into a ZIP archive.</div>
        </b-form-radio>
      </b-form-group>
    </b-modal>

    <b-modal
      id="student-download-modal"
      title="Download Student Form"
      ok-title="Download"
      @ok="downloadStudentPdf()"
      cancel-title="Cancel"
    >
      <b-form-group>
        <b-form-radio v-model="studentDownloadType" value="single_file" class="mb-2">
          <div>PDF</div>
          <div class="text-muted" style="font-size: 0.85rem;">Form only, without attachments.</div>
        </b-form-radio>
        <b-form-radio v-model="studentDownloadType" value="single_file_with_attachment">
          <div>PDF + Attachment</div>
          <div class="text-muted" style="font-size: 0.85rem;">Form merged with uploaded PDF attachments.</div>
        </b-form-radio>
      </b-form-group>
    </b-modal>

    <div class="table-responsive rounded">
      <table class="table table-striped table-bordered">
        <thead class="thead-dark text-left">
          <tr>
            <th rowspan="2" style="padding: 10px; border: 1px solid #ddd;">Student Name</th>
            <th v-if="gridColumns.length"
              :colspan="gridColumns.length" class="text-center">
              Questions
            </th>
          </tr>
          <tr v-if="gridColumns.length">
            <th v-for="question in gridColumns" :key="question.columnKey"
              class="question-header-cell"
              v-b-popover.hover.top="question.question_no + ') ' + question.name">
              <div class="question-header-text">{{ question.question_no }}) {{ question.name }}</div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="application in admissionFormDetails.applications" :key="application.id">
            <td class="d-flex justify-content-between align-items-center"
              style="padding: 10px; border: 1px solid #ddd;">
              <div class="d-flex align-items-center" style="gap: 6px;">

                <span class="font-weight-bold text-dark d-flex align-items-center" style="gap: 6px;">
                  {{ application.name }}
                  <span class="text-danger" v-if="getPendingOrder(application.id)">
                    {{ pendingApproval[application.id] }}
                  </span>

                  <button
                    v-if="getApprovalStatus(application.id) !== 'approved' && admissionFormDetails.approvers[0].order == 1"
                    class="btn btn-success btn-sm" @click="verifyAllAnswerOfSelectedStudent(application.id)">
                    Verify All
                  </button>

                  <button
                    v-if="getApprovalStatus(application.id) !== 'approved' && admissionFormDetails.approvers[0].order != 1 && !getPendingOrder(application.id)"
                    class="btn btn-success btn-sm" @click="verifyAllAnswerOfSelectedStudent(application.id)">
                    Verify All
                  </button>

                 
                  <button
                    v-if="getApprovalStatus(application.id) === 'approved' && getApplicationApproval(application.id).submit == 0"
                    class="btn btn-info btn-sm"
                    @click="undoverifyAllAnswerOfSelectedStudent(application.id)"
                    title="Undo Verification"
                  >
                    <i class="fas fa-undo text-white" style="font-size: 12px !important;"></i>
                  </button>

                </span>

                <span v-if="getApprovalStatus(application.id) === 'approved'" style="gap: 6px;"
                  class="d-flex align-items-center">

                  <button v-if="getApplicationApproval(application.id).submit == 0" class="btn btn-info btn-sm"
                    @click="confirmSubmitionSelectedStudent(application.id)">
                    Submit
                  </button>
                  <span class="text-success" v-if="getApplicationApproval(application.id).submit == 1">Submitted</span>
                </span>

                <i @click="openStudentPopup(application)" class="fas fa-external-link-alt text-info"
                  title="View Responses"></i>
                <i class="fas fa-download text-success ml-1" style="cursor: pointer; font-size: 0.85rem;"
                  @click="openStudentDownloadModal(application)" title="Download PDF"></i>
              </div>
            </td>

            <td v-for="question in gridColumns" :key="question.columnKey"
              style="padding: 10px; border: 1px solid #ddd;">
              {{ getColumnAnswer(application.answers, question) }}
              <div v-if="question.dependentPart !== 'sub' && getUploads(application.answers, question.id).length" class="mt-2">
                <div class="uploaded-files">
                  <div v-for="(file, index) in getUploads(application.answers, question.id)" :key="index"
                    class="file-item">
                    <a :href="userAttachments + file.file_path + file.file_name" target="_blank" class="file-link"
                      :title="file.file_name">
                      {{ formatFileName(file.file_name) }}
                    </a>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Student Details Popup (Using b-modal) -->
    <b-modal v-model="showPopup" title="Student Responses" hide-footer size="xl">
      <h4 class="text-center" style="font-size: 20px; font-weight: bold; margin-bottom: 15px;">
        {{ selectedStudent.name }}
      </h4>
      <div class="text-center mb-3">

        <span v-if="!getPendingOrder(selectedStudent.id)">
          <b-button
            v-if="getApprovalStatus(selectedStudent.id) !== 'approved' &&
              admissiondesk && (!getApplicationApproval(selectedStudent.id) || getApplicationApproval(selectedStudent.id).submit == 0)"
            :disabled="verifyAllBtn || selectedStudent.verified" variant="success" class="mb-3"
            style="position: absolute; top: 10px; left: 10px;" @click="verifyAll">
            {{ verifyAllBtn ? 'Verification Inprogress....' : 'Verify All' }}


          </b-button>
        </span>

      </div>
      <div class="table-responsive rounded">
        <table class="table table-striped table-bordered">
          <thead class="thead-dark text-left">
            <tr>
              <th class="p-2">Question</th>
              <th class="p-2">Response</th>
              <th v-if="admissiondesk" class="p-2"></th>
              <th v-if="admissiondesk" class="p-2"></th>
              <th class="p-2">Modified By & At</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(question, questionIndex) in admissionFormDetails.admissionformquestions">
            <tr :key="questionIndex">
              <td class="p-2">
                {{ question.question_no }}) {{ question.name }}
              </td>
              <td class="p-2">
                <template v-if="editingQuestionId === question.id">
                  <div class="answerField mb-3"
                    v-if="question.input_attributes[0].shortAnswer || question.input_attributes[0].paragraph">
                    <b-form-input :value="getAnswer(selectedStudent.answers, question.id)" placeholder="Enter Answer"
                      v-model="modifiedAnswer" class="form-control shadow-sm"></b-form-input>
                  </div>

                  <div class="multichoice mb-3" :value="getAnswer(selectedStudent.answers, question.id)"
                    v-if="question.input_attributes[0].multiChoice">
                    <!-- <b-form-checkbox-group v-model="modifiedAnswer" :options="question.choices"
                      class="shadow-sm"> -->
                    <b-form-checkbox-group v-model="modifiedAnswer" :options="question.choices" class="small" />
                  </div>

                  <div class="checkboxes mb-3" v-if="question.input_attributes[0].checkboxes">
                    <b-form-radio-group v-model="modifiedAnswer"
                      :value="getAnswer(selectedStudent.answers, question.id)" :options="question.choices"
                      class="shadow-sm"></b-form-radio-group>
                  </div>

                  <div class="dropdown mb-3" :value="getAnswer(selectedStudent.answers, question.id)"
                    v-if="question.input_attributes[0].dropdown">
                    <b-form-select v-model="modifiedAnswer" :options="question.choices"
                      class="shadow-sm"></b-form-select>
                  </div>

                  <!-- calendar / DOB: native date input (YYYY-MM-DD), the answer stays DD-MM-YYYY -->
                  <div class="mb-3" v-if="question.input_attributes[0].date || question.input_attributes[0].dob">
                    <b-form-input type="date" :value="dateToIso(modifiedAnswer)"
                      @change="modifiedAnswer = isoToDate($event)"
                      :max="isDobQuestion(question) ? todayIso() : null"
                      class="shadow-sm" style="max-width: 200px;"></b-form-input>
                    <small v-if="isDobQuestion(question) && ageFromDob(modifiedAnswer)" class="text-muted">
                      Age: {{ ageFromDob(modifiedAnswer) }}
                    </small>
                  </div>

                  <div class="mb-3" v-if="question.input_attributes[0].dependentDropdown">
                    <b-form-select v-model="dependentMain" :options="dependentMainChoices(question)"
                      @change="onDependentChange(question, true)" class="shadow-sm"></b-form-select>
                    <!-- the sub drop-down sits in its own row below when the question has a sub question -->
                    <b-form-select v-if="!hasSubQuestionRow(question)" :disabled="dependentSubChoices(question).length <= 1"
                      v-model="dependentSub" :options="dependentSubChoices(question)"
                      @change="onDependentChange(question, false)" class="shadow-sm mt-1"></b-form-select>
                  </div>


                  <!-- Attachment Field -->
                  <div class="attachment mb-2" v-if="question.allow_attachment">
                    <div class="text-right mt-3">
                      <span class="text-info btn p-0 m-0" @click="newFileInputMask(question.id)">
                        <i class="fas fa-paperclip fa-2x"></i>
                      </span>


                      <b-form-file class="text-info btn p-0 m-0" :ref="'newFileInput' + question.id" type="file"
                        @change="newFileInput($event.target.files, question.id)" style="display: none"></b-form-file>
                      <div class="text-left" style="overflow: hidden">
                        <div class="d-flex flex-column">
                          <span class="text-dark ml-3"
                            v-for="(file, fileIndex) in getUploads(selectedStudent.answers, question.id)"
                            :key="fileIndex">
                            <a :href="userAttachments + file.file_path + file.file_name" target="_blank"
                              class="text-decoration-none" style="font-size: 14px; font-weight: 600">
                              {{ file.file_name }}
                            </a>
                            <span class="btn p-0 m-0 ml-2 text-danger" @click="deleteAnswerAttachment(file.id)">
                              <i class="fas fa-trash"></i>
                            </span>
                          </span>
                        </div>
                      </div>

                      <div v-if="newQuestionsAnswerAttachments[question.id]">
                        <span class="text-dark ml-3" v-for="(newFile,
                          newFileIndex) in newQuestionsAnswerAttachments[
                          question.id
                          ]" :key="newFileIndex">
                          <b-progress :value="uploadPercentage[question.id].value" :max="100" show-progress
                            animated></b-progress>
                          <span>
                            {{ newFile }}
                            <br />
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <template v-if="hasSubQuestionRow(question)">
                    {{ splitDependentAnswer(question, getAnswer(selectedStudent.answers, question.id)).main || getAnswer(selectedStudent.answers, question.id) }}
                  </template>
                  <template v-else>{{ getAnswer(selectedStudent.answers, question.id) }}</template>
                  <small v-if="isDobQuestion(question) && ageFromDob(getAnswer(selectedStudent.answers, question.id))"
                    class="text-muted">(Age: {{ ageFromDob(getAnswer(selectedStudent.answers, question.id)) }})</small>
                  <div v-if="getUploads(selectedStudent.answers, question.id).length" class="mt-2">
                    <div class="uploaded-files">
                      <div v-for="(file, index) in getUploads(selectedStudent.answers, question.id)" :key="index"
                        class="file-item">
                        <a :href="userAttachments + file.file_path + file.file_name" target="_blank" class="file-link"
                          :title="file.file_name">
                          {{ formatFileName(file.file_name) }}
                        </a>
                      </div>
                    </div>
                  </div>
                </template>
              </td>
              <td v-if="admissiondesk" :rowspan="hasSubQuestionRow(question) ? 2 : 1" class="p-1 flex items-center gap-1">
                <div v-if="editingQuestionId === question.id">
                  <b-button variant="primary" class="bg-blue-500 hover:bg-blue-600 text-white p-1 rounded-md mr-2"
                    @click="confirmModification(question)">
                    Submit
                  </b-button>
                  <b-button variant="danger" class="bg-blue-500 hover:bg-blue-600 text-white p-1 rounded-md"
                    @click="refreshPopup()">
                    Cancel
                  </b-button>
                </div>
                <!-- an OTP verified phone no. can only be changed by the applicant re-verifying it -->
                <small v-else-if="question.input_attributes[0].phoneOtp" class="text-muted">OTP verified, can't be modified</small>
                <div v-else>
                  <b-button v-if="!getPendingOrder(selectedStudent.id)"
                    :disabled="isVerified(question.id) || verifyingQuestionId !== null" variant="info"
                    class="bg-yellow-500 hover:bg-yellow-600 text-white p-1 rounded-md disabled:opacity-50"
                    @click="editAnswer(question)">
                    Modify
                  </b-button>
                </div>
              </td>
              <td v-if="admissiondesk" :rowspan="hasSubQuestionRow(question) ? 2 : 1" class="p-1 flex items-center gap-1">
                <!-- Verify Button -->
                <b-button :disabled="editingQuestionId" variant="success" @click="confirmVerification(question)"
                  v-if="!isVerified(question.id) && !getPendingOrder(selectedStudent.id)"
                  class="bg-green-500 hover:bg-green-600 text-white p-1 rounded-md disabled:opacity-50">
                  Verify
                </b-button>

                <span v-if="isVerified(question.id)">
                  <span class="text-success">Verified</span>
                  <div v-if="getVerifiedBy(question.id)" style="font-size: 12px; color: #555;">
                    {{ getVerifiedBy(question.id) }}
                  </div>
                </span>
                
                <button
                  v-if="isVerified(question.id) &&
                        (!getApplicationApproval(selectedStudent.id) || getApplicationApproval(selectedStudent.id).submit == 0)"
                  class="btn btn-info p-1 ml-2"
                  @click="undoVerification(question)"
                  :disabled="editingQuestionId"
                  title="Undo Verification"
                  style="width: 28px; height: 28px; display: flex; align-items: center; justify-content: center;"
                >
                  <i class="fas fa-undo text-white" style="font-size: 12px !important;"></i>
                </button>

                <!-- <i class="fas fa-angle-down text-info ml-1" style="cursor: pointer;"
                  @click="toggleVerificationDetails(question.id)"></i> -->

                <!-- Toggle Content -->
                <!-- Trigger button/link -->
                <div v-if="isVerified(question.id)"
                  style="font-size: 12px; color: #007bff; cursor: pointer; margin-top: 5px;"
                  @click="$bvModal.show('verification-modal-' + question.id)">
                  Verification Log
                </div>

                <!-- Popup Modal -->
                <b-modal :id="'verification-modal-' + question.id" title="Verification Details" size="lg" hide-footer>
                  <div v-for="(line, index) in getFormattedVerificationDetails(question.id)" :key="index">
                    <span v-html="line"></span>
                  </div>
                </b-modal>


              </td>


              <td class="p-2" :rowspan="hasSubQuestionRow(question) ? 2 : 1">

                <div v-for="ans in selectedStudent.answers" :key="ans.question_id">

                  <div
                    v-if="ans.question_id === question.id && (ans.modification_details && ans.modification_details.length)">
                    <!-- Show only latest -->

                    <span>
                      {{ getFacultyName(ans.modification_details.at(-1).modified_by) }} -
                      {{ ans.modification_details.at(-1).modified_at }}
                    </span>

                    <!-- Toggle icon -->
                    <!-- <i class="fas fa-angle-down text-info ml-1" style="cursor: pointer;"
                      @click="toggleExpanded(question.id)"></i> -->


                    <!-- Trigger button/link -->
                    <div style="font-size: 12px; color: #007bff; cursor: pointer; margin-top: 5px;"
                      @click="$bvModal.show('modification-modal-' + question.id)">
                      Modification Log
                    </div>

                    <!-- Popup Modal -->
                    <b-modal :id="'modification-modal-' + question.id" title="Modification Details" size="lg"
                      hide-footer>
                      <ul>
                        <li v-for="mod in ans.modification_details" :key="mod.modified_at">
                          {{ getFacultyName(mod.modified_by) }} - {{ mod.modified_at }}
                        </li>
                      </ul>
                    </b-modal>




                    <!-- Extension showing other modifications (excluding latest) -->
                    <div v-if="expandedQuestionId === question.id" class="mt-2">
                      <ul>
                        <li v-for="mod in ans.modification_details" :key="mod.modified_at">
                          {{ getFacultyName(mod.modified_by) }} - {{ mod.modified_at }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </td>

            </tr>
            <!-- dependent drop-down: the sub question gets its own row; Modify / Verify above cover both -->
            <tr v-if="hasSubQuestionRow(question)" :key="questionIndex + '-sub'">
              <td class="p-2">
                {{ question.answers.sub_question_no || question.question_no + '.1' }}) {{ question.answers.sub_question }}
              </td>
              <td class="p-2">
                <b-form-select v-if="editingQuestionId === question.id" :disabled="dependentSubChoices(question).length <= 1"
                  v-model="dependentSub" :options="dependentSubChoices(question)"
                  @change="onDependentChange(question, false)" class="shadow-sm"></b-form-select>
                <template v-else>
                  {{ splitDependentAnswer(question, getAnswer(selectedStudent.answers, question.id)).sub || '-' }}
                </template>
              </td>
            </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="text-center mt-3">
        <b-button variant="danger" @click="showPopup = false">Close</b-button>
      </div>
    </b-modal>

    <!-- Confirmation Modal -->
    <b-modal id="showConfirmPopup" title="Confirm Action" hide-footer>
      <p>Are you sure you want to modify question number {{ confirmQuestionNo }} - "{{ confirmQuestionName }}"?</p>
      <p><strong>Answer:</strong>{{ Array.isArray(confirmAnswer) ? confirmAnswer.join(', ') : confirmAnswer }}</p>
      <div class="text-center">
        <b-button variant="danger" class="mr-2" @click="submitModification">Yes</b-button>
        <b-button variant="secondary" @click="$bvModal.hide('showConfirmPopup')">No</b-button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { dependentOptions, subOptionsFor, joinDependentAnswer, splitDependentAnswer } from "./dependentDropdown";
import { isDobQuestion, ageFromDob } from "./dobAge";
export default {
  props: {
    initialSectionId: { default: null },
    initialAdmissiondesk: { default: null },
    initialAdminroleAdmissiondesk: { default: null },
  },
  data() {
    return {
      sectionId: null,
      expandedVerifications: {},
      expandedQuestionId: null,
      showPopup: false,
      admissionFormDetails: { admissionformquestions: [], applications: [], approvers: [], allapprovers: [] },
      approver: null,
      newQuestionsAnswerAttachments: {},
      uploadPercentage: {},
      userAttachments: null,
      selectedStudent: {},
      admissiondesk: false,
      adminrole_admissiondesk: false,
      verifiedAnswers: {},
      confirmQuestionId: null,
      confirmQuestionNo: null,
      confirmQuestionName: '',
      confirmAnswer: '',
      verifyAllBtn: false,
      editingQuestionId: null,
      verifyingQuestionId: null,
      modifiedAnswer: [],
      oldAnswer: "",
      dependentMain: null,
      dependentSub: null,
      facultyOptions: [],
      // institution user id -> name, from the verifier the API sends with each answer approval
      verifierNames: {},
      pendingApproval: {},
      activeFormId: null,
      selectedExportType: 'single_file',
      studentDownloadType: 'single_file',
      selectedStudentForDownload: null,
      loadReport: false,
    };
  },
  async created() {
    this.admissiondesk = this.initialAdmissiondesk !== null
      ? (this.initialAdmissiondesk === true || this.initialAdmissiondesk === "true")
      : (this.$route.params.admissiondesk === "true" || this.$route.query.admissiondesk === "true");
    this.adminrole_admissiondesk = this.initialAdminroleAdmissiondesk !== null
      ? (this.initialAdminroleAdmissiondesk === true || this.initialAdminroleAdmissiondesk === "true")
      : (this.$route.params.adminrole_admissiondesk === "true" || this.$route.query.adminrole_admissiondesk === "true");
    this.sectionId = this.initialSectionId !== null
      ? this.initialSectionId
      : this.sectionId;
    this.userAttachments = this.$store.getters.getAPIKey.userAttachments;
    await this.fetchInstitutionFaculties();
    await this.getAdmissionFormDetails();
  },
  computed: {
    // grid columns: a dependent drop-down adds a column for its sub question (the popup shows it as a second row instead)
    gridColumns() {
      return (this.admissionFormDetails.admissionformquestions || []).reduce((columns, question) => {
        columns.push({ ...question, columnKey: String(question.id), dependentPart: this.hasSubQuestionRow(question) ? "main" : null });
        if (this.hasSubQuestionRow(question)) {
          columns.push({
            ...question,
            columnKey: question.id + "-sub",
            dependentPart: "sub",
            name: question.answers.sub_question,
            question_no: question.answers.sub_question_no || question.question_no + ".1",
          });
        }
        return columns;
      }, []);
    },
  },
  methods: {
    isDobQuestion,
    ageFromDob,
    splitDependentAnswer,
    hasSubQuestionRow(question) {
      return !!(question.input_attributes[0].dependentDropdown && question.answers && question.answers.sub_question);
    },
    async downloadAdmissionformFullDetails() {
      this.loadReport = true;
      const url = this.$store.getters.getAPIKey.mainAPI + `/admissionforms/${this.activeFormId}/pdfexport`;

      const isZip = [
        'all_students_individual',
        'all_students_individual_with_attachment',
      ].includes(this.selectedExportType);

      const blobType = isZip ? 'application/zip' : 'application/pdf';
      const fileName = isZip ? 'Admissionforms.zip' : 'Admissionform.pdf';

      await this.$axios
        .post(url, { type: this.selectedExportType }, { responseType: 'blob' })
        .then((response) => {
          const fileBlob = new Blob([response.data], { type: blobType });
          const fileUrl = window.URL.createObjectURL(fileBlob);
          const link = document.createElement('a');
          link.href = fileUrl;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((error) => {
          let errorText = 'Failed to Download, please check connectivity';
          if (error.response != undefined)
            errorText = error.response.status == 422
              ? 'Custom report is not configured by admin'
              : 'Failed to Download, please try again';
          this.$toasted.error(errorText, { duration: 3000 });
        });
      this.loadReport = false;
    },

    openStudentDownloadModal(application) {
      this.selectedStudentForDownload = application;
      this.studentDownloadType = 'single_file';
      this.$bvModal.show('student-download-modal');
    },

    async downloadStudentPdf() {
      const application = this.selectedStudentForDownload;
      const url = this.$store.getters.getAPIKey.mainAPI +
        `/admissionforms/${this.activeFormId}/applications/${application.id}/pdfexport`;
      const safeName = (application.name || application.id).toString().replace(/[^A-Za-z0-9_-]/g, '_');
      await this.$axios
        .post(url, { type: this.studentDownloadType }, { responseType: 'blob' })
        .then((response) => {
          const fileBlob = new Blob([response.data], { type: 'application/pdf' });
          const fileUrl = window.URL.createObjectURL(fileBlob);
          const link = document.createElement('a');
          link.href = fileUrl;
          link.setAttribute('download', safeName + '.pdf');
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(() => {
          this.$toasted.error('Failed to download, please try again', { duration: 3000 });
        });
    },

    closeWindow() {
      if (this.initialSectionId !== null) {
        this.$emit('close');
      } else {
        window.close();
      }
    },
    getPendingOrder(applicationId) {
      let currentOrder = this.admissionFormDetails.approvers[0].order;

      // group approvers by order
      let grouped = {};
      this.admissionFormDetails.allapprovers.forEach(a => {
        if (!grouped[a.order]) grouped[a.order] = [];
        grouped[a.order].push(a);
      });

      // check all orders before currentOrder
      for (let order = 1; order < currentOrder; order++) {
        let approvers = grouped[order] || [];
        if (approvers.length === 0) continue;

        let total = approvers.length;
        let approved = approvers.filter(a =>
          a.approvals.some(appr =>
            appr.application_id === applicationId && appr.submit === 1
          )
        ).length;

        // console.log("aaa",approvers.filter(a =>
        //           a.approvals.some(appr => appr.application_id === applicationId)
        //         ))
        if (approved < total) {
          this.pendingApproval[applicationId] = `Pending in order ${order}`
          return true;  // found pending in previous order
        }
      }

      return false; // all previous orders complete
    },

    async submitSection(sectionId, sectionApproverId) {
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/admissionformsections/submit?section_approver_id=${sectionApproverId}&section_id=${sectionId}`;
        await this.$axios.post(url); // ✅ send as body instead of query param
        this.getAdmissionFormDetails();

        this.$toast?.success("Section submitted successfully"); // optional feedback
      } catch (error) {
        console.error("Submit failed:", error);
        this.$toast?.error("Failed to submit section"); // optional feedback
      }
    },

    toggleVerificationDetails(questionId) {
      this.$set(this.expandedVerifications, questionId, !this.expandedVerifications[questionId]);
    },

    getFormattedVerificationDetails(questionId) {
      let verifications = this.getVerificationDetails(questionId);

      if (!Array.isArray(verifications)) {
        try {
          verifications = JSON.parse(verifications);
        } catch (e) {
          return [];
        }
      }

      return verifications
        .slice() // clone the array to avoid mutating the original
        .reverse() // reverse the order
        .map(entry => {
          const name = this.getFacultyName(entry.verified_by);
          const formattedDate = entry.verified_at;

          const isUndo = entry.action === 'undo_verify';
          const actionText = isUndo ? 'Undo' : 'Verify';
          const colorClass = isUndo ? 'text-danger' : 'text-success';

          return `<span>${name} - ${formattedDate} <span class="${colorClass}">(${actionText})</span></span>`;
        });
    },

    toggleExpanded(qId) {
      this.expandedQuestionId = this.expandedQuestionId === qId ? null : qId;
    },
    getModificationDetails(qId) {
      const ans = this.selectedStudent.answers.find(a => a.question_id === qId);
      return ans ? ans.modification_details : [];
    },
    // the staff list leaves out admission coordinators, so fall back to the verifier names sent with the answers
    getFacultyName(id) {
      const faculty = this.facultyOptions.find(f => f.id == id);
      if (faculty) return faculty.name.trim();
      return this.verifierNames[id] ? this.verifierNames[id].trim() : 'Unknown';
    },

    toggleVerificationExpanded(qId) {
      this.expandedVerificationQuestionId =
        this.expandedVerificationQuestionId === qId ? null : qId;
    },

    getOlderVerifications(verifications) {
      // Return all except the last one, in reverse chronological order
      return verifications.slice(0, -1).reverse();
    },

    getApprovalStatus(applicationId) {
      const approvals = this.admissionFormDetails.approvers[0]?.approvals || [];
      const match = approvals.find(approval =>
        approval.application_id === applicationId &&
        approval.approval_status === 'approved'
      );
      return match ? match.approval_status : null;
    },
    getApplicationApproval(applicationId) {
      const approvals = this.admissionFormDetails.approvers[0]?.approvals || [];
      const match = approvals.find(approval =>
        approval.application_id === applicationId &&
        approval.approval_status === 'approved'
      );
      return match ? match : null;
    },

    async fetchInstitutionFaculties() {
      // include admission coordinators: they modify and verify answers too, and the logs only store their id
      const url = `${this.$store.getters.getAPIKey.mainAPI}/institutionusers/faculties?with_admission_coordinators=1`;
      try {
        const response = await this.$axios.get(url);
        this.facultyOptions = response.data
          .filter(staff => staff.enroll_status === 'active')
          .map(staff => ({
            id: staff.id,
            name: `${staff.first_name} ${staff.last_name}`
          }));
      } catch (error) {
        console.error("Error fetching faculty data:", error);
      }
    },
    formatFileName(name) {
      // Optional: trim or shorten long names
      if (name.length > 30) {
        return name.slice(0, 25) + '...';
      }
      return name;
    },
    newFileInputMask(questionId) {
      let elementReference = `${"newFileInput" + questionId}`;
      this.$refs[elementReference][0].$refs.input.click();
    },
    async newFileInput(file, questionId) {
      this.$set(this.newQuestionsAnswerAttachments, questionId, []);
      this.newQuestionsAnswerAttachments[questionId].push(file.name);

      this.$set(this.uploadPercentage, questionId, {});
      this.$set(this.uploadPercentage[questionId], "value", 0);

      let index = this.newQuestionsAnswerAttachments[questionId].indexOf(
        file.name
      );

      await this.uploadAttachment(file[0], questionId);

      await this.newQuestionsAnswerAttachments[questionId].splice(index, 1);

      this.getUplodedAnswer(questionId);
      // // this.initiateAdmissionForm();
    },
    async getUplodedAnswer() {
      this.fetchData = true;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/admissionformsapplications/${this.selectedStudent.id}/onlinereganswers`;
      try {
        const response = await this.$axios.get(url);
        response;
        // Fetch updated details
        await this.getAdmissionFormDetails();
        // Update selected student in the popup
        this.selectedStudent = this.admissionFormDetails.applications.find(app => app.id === this.selectedStudent.id) || {};
      } catch (error) {
        console.error("Error fetching uploaded answers:", error);
      } finally {
        this.fetchData = false; // Ensuring `fetchData` is set to false after API call
      }
    },
    async uploadAttachment(file, questionId) {
      let formData = await new FormData();

      await formData.append("question_id", questionId);
      await formData.append("answer", null);
      await formData.append(
        "application_id",
        this.selectedStudent.id
      );
      await formData.append("attachment", file);
      // await formData.append("file", file);

      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/admissionformsanswers/attachmentanswer`;
      await this.$axios
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage[questionId].value = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
        .then((response) => {
          response;
        })
        .catch((error) => {
          error;
        });
      // file;
      // this.uploadPercentage[questionId]["value"] = await 50;
    },
    async deleteAnswerAttachment(fileId) {
      this.loadAnswer = true;

      const url = this.$store.getters.getAPIKey.mainAPI +
        `/admissionformsanswers/attachments/${fileId}`;

      try {
        await this.$axios.delete(url);

        this.$toast.success("Attachment Deleted.", {
          position: "top",
          duration: 3000,
        });

        // Fetch updated details
        await this.getAdmissionFormDetails();
        // Update selected student in the popup
        this.selectedStudent = this.admissionFormDetails.applications.find(app => app.id === this.selectedStudent.id) || {};
      } catch (error) {
        console.error("Error deleting attachment:", error);
        this.$toast.error("Failed to delete attachment.", {
          position: "top",
          duration: 3000,
        });
      } finally {
        this.loadAnswer = false;
      }
    },

    editAnswer(question) {
      this.editingQuestionId = question.id;
      this.verifyingQuestionId = null;
      const answerObj = this.selectedStudent.answers.find(ans => ans.question_id === question.id);

      if (question.input_attributes[0].multiChoice) {
        // Ensure array format
        if (Array.isArray(answerObj?.answer)) {
          this.modifiedAnswer = answerObj.answer;
        } else if (typeof answerObj?.answer === "string" && answerObj.answer.includes(",")) {
          this.modifiedAnswer = answerObj.answer.split(",").map(a => a.trim());
        } else if (answerObj?.answer) {
          this.modifiedAnswer = [answerObj.answer];
        } else {
          this.modifiedAnswer = [];
        }
      } else {
        // For all other inputs, keep as string
        this.modifiedAnswer = answerObj?.answer || "";
      }

      if (question.input_attributes[0].dependentDropdown) {
        const { main, sub } = splitDependentAnswer(question, answerObj?.answer);
        this.dependentMain = main;
        this.dependentSub = sub;
      }
    },
    dependentMainChoices(question) {
      return [{ value: null, text: "Select One" }].concat(
        dependentOptions(question).map((o) => ({ value: o.option, text: o.option }))
      );
    },
    dependentSubChoices(question) {
      return [{ value: null, text: "Select One" }].concat(
        subOptionsFor(question, this.dependentMain).map((s) => ({ value: s, text: s }))
      );
    },
    onDependentChange(question, mainChanged) {
      if (mainChanged) this.dependentSub = null;
      this.modifiedAnswer = joinDependentAnswer(question, this.dependentMain, this.dependentSub) || "";
    },

    confirmModification(question) {
      const answerObj = this.selectedStudent.answers.find(ans => ans.question_id === question.id);
      this.oldAnswer = answerObj?.answer || "";
      this.confirmQuestionNo = question.question_no;
      this.confirmQuestionId = question.id;
      this.confirmQuestionName = question.name;
      this.confirmAnswer = this.modifiedAnswer;
      this.$bvModal.show('showConfirmPopup');
    },
    async submitModification() {
      try {
        let finalAnswer = this.modifiedAnswer;

        // Convert multi-choice answers back to comma-separated string
        if (Array.isArray(this.modifiedAnswer)) {
          finalAnswer = this.modifiedAnswer.join(", ");
        }

        await this.$axios.post(`${this.$store.getters.getAPIKey.mainAPI}/admissionformsanswers/manage_answers`, {
          application_id: this.selectedStudent.id,
          section_id: this.sectionId,
          question_id: this.editingQuestionId,
          new_answer: finalAnswer,
          old_answer: this.oldAnswer,
          is_modify: true
        });

        this.$toast.success("Answer modified successfully", { position: "top-right", duration: 3000 });
        this.editingQuestionId = null;
        this.confirmQuestionNo = null;
        this.confirmQuestionId = null;
        this.confirmQuestionName = null;
        this.confirmAnswer = null;
        this.oldAnswer = null;
        this.showConfirmPopup = false;
        this.refreshPopup();
      } catch (error) {
        this.$toast.error("Modification failed!", { position: "top-right", duration: 3000 });
      }
    },

    async confirmSubmitionSelectedStudent(applicationId) {
      if (confirm("Once submitted, you cannot verify or modify the details of this student. Do you want to continue?")) {
        await this.submitSelectedStudent(applicationId);
      }
    },

    async submitSelectedStudent(applicationId) {
      try {
        const response = await this.$axios.post(`${this.$store.getters.getAPIKey.mainAPI}/admissionformsanswers/submit`, {
          application_id: applicationId,
          section_id: this.sectionId,
        });

        // final approval generates the admission no.
        const admissionNo = response.data?.admission_no;
        if (admissionNo) {
          this.$toast.success(`Submitted successfully. Admission No. ${admissionNo} generated.`, { position: "top-right", duration: 8000 });
        } else {
          this.$toast.success("Submitted successfully", { position: "top-right", duration: 3000 });
        }
        await this.getAdmissionFormDetails();
      } catch (error) {
        this.$toast.error("Submission failed! Please try again.", { position: "top-right", duration: 3000 });
        console.error("Error submitting form:", error);
      }

      this.verifyAllBtn = false;
    },

    async verifyAllAnswerOfSelectedStudent(applicationId) {
      try {
        await this.$axios.post(`${this.$store.getters.getAPIKey.mainAPI}/admissionformsanswers/manage_answers`, {
          application_id: applicationId,
          section_id: this.sectionId,

          is_verify: true,
          verify_all_answers: true
        });

        this.$toast.success("All unverified answers have been verified", { position: "top-right", duration: 3000 });
        await this.getAdmissionFormDetails();
      } catch (error) {
        this.$toast.error("Verification failed! Please try again.", { position: "top-right", duration: 3000 });
        console.error("Error verifying answers:", error);
      }

      this.verifyAllBtn = false;

    },

    async undoverifyAllAnswerOfSelectedStudent(applicationId) {
      try {
        await this.$axios.post(`${this.$store.getters.getAPIKey.mainAPI}/admissionformsanswers/manage_answers`, {
          application_id: applicationId,
          section_id: this.sectionId,
          is_verify: true,
          // undo_verify: true,
          undoverify_all_answers: true
        });

        this.$toast.success("All verified answers have been unverified", { position: "top-right", duration: 3000 });

      } catch (error) {
        this.$toast.error("Verification failed! Please try again.", { position: "top-right", duration: 3000 });
        console.error("Error verifying answers:", error);
      }

      await this.getAdmissionFormDetails();

    },

    async verifyAll() {
      const applicationId = this.selectedStudent.id;
      this.verifyAllBtn = true;

      const unverifiedAnswers = this.selectedStudent.answers
        ?.filter(answer => !answer.verified_at)
        .map(answer => answer.question_id);

      if (!unverifiedAnswers.length) {
        this.$toast.info("All answers are already verified", { position: "top-right", duration: 3000 });
        this.verifyAllBtn = false;
        return;
      }

      try {
        await this.$axios.post(`${this.$store.getters.getAPIKey.mainAPI}/admissionformsanswers/manage_answers`, {
          application_id: applicationId,
          section_id: this.sectionId,
          question_ids: unverifiedAnswers,  // Send all question IDs in one request
          is_verify: true,
          verify_all_answers: true
        });

        this.$toast.success("All unverified answers have been verified", { position: "top-right", duration: 3000 });
        this.refreshPopup();
      } catch (error) {
        this.$toast.error("Verification failed! Please try again.", { position: "top-right", duration: 3000 });
        console.error("Error verifying answers:", error);
      }

      this.verifyAllBtn = false;
    },

    isVerified(questionId) {
      const answerObj = this.selectedStudent.answers?.find(ans => ans.question_id === questionId);
      return answerObj?.verified_at && answerObj?.verified_by;
    },

    getVerificationDetails(questionId) {
      const answerObj = this.selectedStudent.answers?.find(
        ans => ans.question_id === questionId
      );

      return `${answerObj?.verification_details}`;
    },

    getVerifiedBy(questionId) {
      const answerObj = this.selectedStudent.answers.find(
        ans => ans.question_id === questionId
      );

      if (!answerObj?.verified_by || !answerObj?.verified_at) return null;

      const formattedDate = answerObj.verified_at; // dd/mm/yyyy format
      return `${answerObj.verified_by} - ${formattedDate}`;
    },

    getModifiedBy(questionId) {
      const answerObj = this.selectedStudent?.answers?.find(
        ans => ans.question_id === questionId
      );

      if (!answerObj?.modification_details) return null;

      return `${answerObj.modification_details}`;
    },


    getAnswer(answers, questionId) {
      return answers?.find(ans => ans.question_id === questionId)?.answer || "";
    },
    // DD-MM-YYYY (saved answer) <-> YYYY-MM-DD (native date input)
    dateToIso(answer) {
      const match = /^(\d{2})-(\d{2})-(\d{4})$/.exec(answer || "");
      return match ? `${match[3]}-${match[2]}-${match[1]}` : "";
    },
    isoToDate(value) {
      const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || "");
      return match ? `${match[3]}-${match[2]}-${match[1]}` : "";
    },
    todayIso() {
      const now = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
    },
    // a dependent drop-down shows its main and sub parts in separate grid columns
    getColumnAnswer(answers, question) {
      const answer = this.getAnswer(answers, question.id);
      if (!question.dependentPart || !answer) return answer;
      const { main, sub } = splitDependentAnswer(question, answer);
      if (question.dependentPart === "main") return main || answer;
      return main ? sub || "" : "";
    },

    getUploads(answers, questionId) {
      return answers?.find(ans => ans.question_id === questionId)?.files || [];
    },

    async getAdmissionFormDetails() {
      const admissionformsectionId = this.sectionId;
      const url = `${this.$store.getters.getAPIKey.mainAPI}/admissionformsections/${admissionformsectionId}`;

      try {
        const { data } = await this.$axios.get(url);
        const verifierNames = {};

        this.activeFormId = data.admissionform?.id || null;

        this.admissionFormDetails = {
          ...data,
          admissionformquestions: data.questions.map(q => {
            let choices = q.input_attributes[0].dropdown ? [{ value: null, text: "Select One" }] : [];

            // dependent drop-down keeps its options as an object, not a plain choice list
            if (Array.isArray(q.answers) && q.answers.length !== 0) {
              choices.push(...q.answers.map(choice => ({ value: choice, text: choice })));
            }

            return {
              id: q.id,
              name: q.name,
              question_no: q.question_no,
              input_attributes: q.input_attributes,
              choices: choices,
              answers: q.answers,
              allow_attachment: q.allow_attachment == 1,
            };
          }),
          approvers: data.approvers,
          allapprovers: data.allapprovers,
          applications: data.admissionform.applications
            .filter(app => app.end_at !== null)
            .map(app => {
              const answers = app.answers?.map(ans => {
                const approval = ans.answerapprovals?.[0] || {}; // handle first approval
                const verifier = approval.verifier;
                (ans.answerapprovals || []).forEach(a => {
                  if (a.verifier) verifierNames[a.verifier.id] = `${a.verifier.first_name} ${a.verifier.last_name}`;
                });

                return {
                  question_id: ans.question_id,
                  answer: ans.answer,
                  files: ans.files || [],
                  verified_at: approval.verified_at || null,
                  verified_by: verifier ? `${verifier.first_name} ${verifier.last_name}` : null,
                  modification_details: ans.modification_details,
                  verification_details: approval.verification_details,
                };
              }) || [];

              const verified = answers.length > 0 && answers.every(ans => ans.verified_at !== null);

              return {
                id: app.id,
                name: app.name,
                email: app.email,
                end_at: app.end_at,
                answers: answers,
                verified: verified,
              };
            }),
        };
        this.verifierNames = verifierNames;
      } catch (error) {
        console.error("Error fetching admission form details:", error);
      }
    },


    openStudentPopup(student) {
      this.selectedStudent = student;
      this.showPopup = true;
      this.refreshPopup();
    },

    async confirmVerification(question) {
      this.verifyingQuestionId = question.id;
      this.editingQuestionId = null; // Disable editing during verification
      this.confirmQuestionId = question.id;
      await this.verifyAnswer();
      this.refreshPopup();
    },

    async undoVerification(question) {
      this.verifyingQuestionId = question.id;
      this.editingQuestionId = null; // Disable editing during verification
      this.confirmQuestionId = question.id;
      await this.verifyAnswer('undo');
      this.refreshPopup();
    },

    async verifyAnswer(verify_status) {
      const application = this.selectedStudent;
      this.$set(this.verifiedAnswers, this.confirmQuestionId, true);
      let undo_verify = false;
      if (verify_status === 'undo') {
        undo_verify = true;
      }

      try {
        await this.$axios.post(`${this.$store.getters.getAPIKey.mainAPI}/admissionformsanswers/manage_answers`, {
          application_id: application.id,
          section_id: this.sectionId,
          question_id: this.confirmQuestionId,
          is_verify: true,
          undo_verify: undo_verify
        });
        if (verify_status == 'undo') {
          this.$toast.success("Undo Verified", { position: "top-right", duration: 3000 });
        }
        else {
          this.$toast.success("Verified", { position: "top-right", duration: 3000 });
        }

      } catch (error) {
        console.error("Error verifying answer:", error);
      }
    },
    async refreshPopup() {
      // Fetch updated details
      await this.getAdmissionFormDetails();
      // Update selected student in the popup
      this.selectedStudent = this.admissionFormDetails.applications.find(app => app.id === this.selectedStudent.id) || {};
      console.log("this.selectedStudent", this.selectedStudent);
      this.editingQuestionId = null;
      this.verifyingQuestionId = null;
      this.confirmQuestionNo = null;
      this.confirmQuestionId = null;
      this.confirmQuestionName = null;
      this.confirmAnswer = null;
      this.$bvModal.hide('showConfirmPopup');
      this.$forceUpdate(); // Ensure Vue updates the component
    }
  },
};
</script>
<style scoped>
.uploaded-files {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.file-item {
  font-size: 14px;
}

.file-link {
  color: #007bff;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.2s ease;
}

.file-link:hover {
  text-decoration: underline;
  color: #0056b3;
}

.file-link i {
  color: #555;
}

b-form-checkbox-group {
  margin-bottom: 0.5rem;
}

.question-header-cell {
  padding: 10px;
  border: 1px solid #ddd;
  max-width: 500px;
  vertical-align: middle;
}

.question-header-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>